import React from 'react';
import { IconFile, IconFolder, IconFolders } from '@tabler/icons-react';

// Types
import { StudyForm } from './types';
// Utils
import { buildFormTree, type FormTreeNode } from './utils/formTreeUtils';

interface FormIconProps {
  form: StudyForm;
  availableForms?: StudyForm[]; // Optional, for determining hierarchy
  size?: number;
  className?: string;
}

export const FormIcon: React.FC<FormIconProps> = ({
  form,
  availableForms,
  size = 16,
  className,
}) => {
  // If we have availableForms, determine hierarchy using buildFormTree
  if (availableForms) {
    const formTree = buildFormTree(availableForms);

    // Create a flat map for quick lookup
    const formMap = new Map<number, FormTreeNode>();
    const buildMap = (nodes: FormTreeNode[]) => {
      nodes.forEach(node => {
        formMap.set(node.id, node);
        if (node.children) buildMap(node.children);
      });
    };
    buildMap(formTree);

    // Check if this form has children in the hierarchy
    const treeNode = formMap.get(form.id);
    const hasChildren = (treeNode?.children?.length ?? 0) > 0;

    return hasChildren ? (
      <IconFolders className={className} size={size} />
    ) : (
      <IconFolder className={className} size={size} />
    );
  }

  // Fallback: use form type if available
  if (form.type === 1) {
    // Main form
    return <IconFolder className={className} size={size} />;
  } else if (form.type === 2) {
    // Subform
    return <IconFile className={className} size={size} />;
  }

  // Default fallback
  return <IconFile className={className} size={size} />;
};

export default FormIcon;






